import React, { useRef } from "react";
import PropTypes from "prop-types";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


const CompanyBlock = ({ title, btn_text, page, points = [] }) => {
  const wrapperRef = useRef(null);
  const blockRef = useRef(null);

  return (
    <div className="company-block-wrapper" ref={wrapperRef}>
      <div className="company-block" ref={blockRef}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-4 col-lg-6">
              <span className="eyebrow">Félagið</span>
              <h2 className="light title">{title}</h2>
              {btn_text && (
                <a
                  href={page?.url ?? "#"}
                  className="btn-default d-none d-lg-flex"
                >
                  {btn_text}
                </a>
              )}
            </div>
            <div className="col-xl-6 col-lg-6 offset-xl-2 col-md-9">
              <div className="company-block__paragraph">
                {points.map((point, index) => (
                  <div
                    key={index}
                    className="company-paragraph"
                  >
                    {point.value?.title && (
                      <h4 className="paragraph-title">
                        {point.value.title}
                      </h4>
                    )}
                    <p className="p-body-1">{point.value?.text}</p>
                  </div>
                ))}
              </div>
              {btn_text && (
                <a
                  href={page?.url ?? "#"}
                  className="btn-default d-flex d-lg-none"
                >
                  {btn_text}
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

CompanyBlock.propTypes = {
  title: PropTypes.string.isRequired,
  btn_text: PropTypes.string,
  page: PropTypes.shape({
    url: PropTypes.string,
  }),
  points: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.shape({
        title: PropTypes.string,
        text: PropTypes.string,
      }),
    })
  ),
};

export default CompanyBlock;
